import { MutationCache, QueryCache, QueryClient, type Mutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useGlobalStore } from './stores/globalStore';

let activeMutations = 0;

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: () => {
      useGlobalStore.getState().setApiError({isError: true});
    }
  }),
  mutationCache: new MutationCache({
    onMutate: () => {
      activeMutations++;
      useGlobalStore.getState().setLoading(true);
    },
    onSettled: () => {
      activeMutations--;
      if (activeMutations === 0) useGlobalStore.getState().setLoading(false);
    },
    onError: (error: unknown, _variables: unknown, _context: unknown, mutation: Mutation<unknown, unknown, unknown, unknown>) => {
      if (mutation.options.mutationKey?.[0] === 'placeOrder') {
        const err = error as AxiosError | undefined;
        if (err?.response?.status === 400) {
          useGlobalStore.getState().setBypassOTPError(true);
          return;
        }
      }
      useGlobalStore.getState().setApiError({isError: true});
    }
  }),
  defaultOptions: {
    queries: {
      retry: (failureCount: number, error: unknown) => {
        const err = error as AxiosError | undefined;
        const status = err?.response?.status;
        if (status === 502) return failureCount < 3;
        if (!err?.response) return failureCount < 1;
        return false;
      },
      retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 30000),
      staleTime: 1000 * 60 * 2,
    },
    mutations: {
      retry: (failureCount: number, error: unknown) => {
        const err = error as AxiosError | undefined;
        return err?.response?.status === 502 && failureCount < 2;
      },
      retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 30000),
    },
  },
});
